"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var components_1 = require("@lsg/components");

var AdjacentSectionsRenderer_1 = require("./AdjacentSectionsRenderer");
/**
 * Renders a light theme wrapper with a list of Section elements as children
 */


exports.LightSectionsRenderer = function (_a) {
  // console.log('LightSectionsRenderer');
  var data = _a.data,
      props = _a.props;
  return react_1["default"].createElement(components_1.Theme, {
    look: components_1.Themes.LIGHT
  }, react_1["default"].createElement(AdjacentSectionsRenderer_1.AdjacentSectionsRenderer, {
    data: data,
    props: props,
    component: react_1["default"].Fragment
  }));
};